import { c as _c } from "react-compiler-runtime";
import { useMagpieTopic } from 'collaboration-sidebar-common/utils/magpie';
import { isCollaborationSidebarTabType } from '../../utils/typeGuards';
import { RequestChangeStudioCardContext, RequestClearStudioCardContext, CollaborationSidebarStateTopic, CommentNavigationTopic, RequestChangeSidebarTab, RequestCloseCollaborationSidebar, RequestCreateTask, RequestHighlightModule, RequestOpenCollaborationSidebar, RequestScrollToModule, TasksTopic, TaskOpened, RealtimeCommentingTopic, ReportNewComment } from './messages';

/**
 * Sidebar open/close
 */

export const useSidebarMessageHandlers = t0 => {
  "use memo";

  const $ = _c(6);
  const {
    onRequestOpenSidebar,
    onRequestCloseSidebar,
    onRequestChangeSidebarTab
  } = t0;
  let t1;
  if ($[0] !== onRequestOpenSidebar) {
    t1 = {
      topic: CollaborationSidebarStateTopic,
      message: RequestOpenCollaborationSidebar,
      onMessage: msg => {
        let tab;
        const payloadTab = msg.payload.tab;
        if (payloadTab && isCollaborationSidebarTabType(payloadTab)) {
          tab = payloadTab;
        }
        onRequestOpenSidebar({
          tab
        });
      }
    };
    $[0] = onRequestOpenSidebar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useMagpieTopic(t1);
  let t2;
  if ($[2] !== onRequestCloseSidebar) {
    t2 = {
      topic: CollaborationSidebarStateTopic,
      message: RequestCloseCollaborationSidebar,
      onMessage: () => {
        onRequestCloseSidebar();
      }
    };
    $[2] = onRequestCloseSidebar;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useMagpieTopic(t2);
  let t3;
  if ($[4] !== onRequestChangeSidebarTab) {
    t3 = {
      topic: CollaborationSidebarStateTopic,
      message: RequestChangeSidebarTab,
      onMessage: msg_0 => {
        onRequestChangeSidebarTab({
          tab: msg_0.payload.tab
        });
      }
    };
    $[4] = onRequestChangeSidebarTab;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useMagpieTopic(t3);
};

/**
 * Task Messages
 */

export const useTaskMessaging = t0 => {
  "use memo";

  const $ = _c(8);
  const {
    onRequestCreateTask,
    onChangeStudioCardContext,
    onClearStudioCardContext,
    onTaskOpened
  } = t0;
  let t1;
  if ($[0] !== onRequestCreateTask) {
    t1 = {
      topic: TasksTopic,
      message: RequestCreateTask,
      onMessage: msg => {
        onRequestCreateTask === null || onRequestCreateTask === void 0 || onRequestCreateTask(msg);
      }
    };
    $[0] = onRequestCreateTask;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useMagpieTopic(t1);
  let t2;
  if ($[2] !== onChangeStudioCardContext) {
    t2 = {
      topic: TasksTopic,
      message: RequestChangeStudioCardContext,
      onMessage: msg_0 => {
        onChangeStudioCardContext === null || onChangeStudioCardContext === void 0 || onChangeStudioCardContext(msg_0);
      }
    };
    $[2] = onChangeStudioCardContext;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useMagpieTopic(t2);
  let t3;
  if ($[4] !== onClearStudioCardContext) {
    t3 = {
      topic: TasksTopic,
      message: RequestClearStudioCardContext,
      onMessage: msg_1 => {
        onClearStudioCardContext === null || onClearStudioCardContext === void 0 || onClearStudioCardContext(msg_1);
      }
    };
    $[4] = onClearStudioCardContext;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useMagpieTopic(t3);
  let t4;
  if ($[6] !== onTaskOpened) {
    t4 = {
      topic: TasksTopic,
      message: TaskOpened,
      onMessage: msg_2 => {
        onTaskOpened === null || onTaskOpened === void 0 || onTaskOpened(msg_2);
      }
    };
    $[6] = onTaskOpened;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useMagpieTopic(t4);
};

/**
 * Deep Commenting messages
 */
export const useDeepCommentingNavigationMessaging = t0 => {
  "use memo";

  const $ = _c(4);
  const {
    onRequestScrollToModule,
    onRequestHighlightModule
  } = t0;
  let t1;
  if ($[0] !== onRequestScrollToModule) {
    t1 = {
      topic: CommentNavigationTopic,
      message: RequestScrollToModule,
      onMessage: msg => {
        onRequestScrollToModule === null || onRequestScrollToModule === void 0 || onRequestScrollToModule(msg);
      }
    };
    $[0] = onRequestScrollToModule;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useMagpieTopic(t1);
  let t2;
  if ($[2] !== onRequestHighlightModule) {
    t2 = {
      topic: CommentNavigationTopic,
      message: RequestHighlightModule,
      onMessage: msg_0 => {
        onRequestHighlightModule === null || onRequestHighlightModule === void 0 || onRequestHighlightModule(msg_0);
      }
    };
    $[2] = onRequestHighlightModule;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useMagpieTopic(t2);
};

/**
 * Realtime commenting messages
 */
export const useRealtimeCommentingMessaging = ({
  onReportNewComment,
  skip
}) => {
  useMagpieTopic({
    topic: RealtimeCommentingTopic,
    message: ReportNewComment,
    onMessage: skip ? undefined : msg => {
      onReportNewComment(msg);
    }
  });
};